import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContainerStateModule } from '®shared/container-structure/state';
import { CurrentUserModule } from '®shared/current-user';
import { EventsModule } from '®shared/events';
import { FocusModule } from '®shared/focus';
import { GoogleAnalyticsGA4Module } from '®shared/google-analytics/google-analytics-ga4';
import { ItemMetadataModule } from '®shared/item-metadata';
import { FieldedItemModule } from '®shared/list-item';
import { PageContentModule } from '®shared/list-item/resource/page-content';
import { ListItemsModule } from '®shared/list-item/store';
import { ReadingListModule } from '®shared/reading-list/models';
import { AvailabilityModule } from '®shared/resource-availability';
import { TenantModule } from '®shared/tenant';
import { UriModule } from '®shared/url-utils';
import { UserAnnotationsModule } from '®shared/user-annotations';

import { itemViewRouting } from './item-view-routing.module';
import { ItemViewComponent } from './item-view.component';
import { ItemResolverModule } from './resolver';
import { SingleItemViewComponent } from './single-item-view.component';

@NgModule({
  imports: [
    CommonModule,
    ContainerStateModule,
    CurrentUserModule,
    AvailabilityModule,
    EventsModule,
    FieldedItemModule,
    FocusModule,
    GoogleAnalyticsGA4Module,
    ItemMetadataModule,
    ItemResolverModule,
    itemViewRouting,
    ListItemsModule,
    PageContentModule,
    ReadingListModule,
    TenantModule,
    UriModule,
    UserAnnotationsModule,
  ],
  declarations: [ItemViewComponent, SingleItemViewComponent],
  exports: [ItemViewComponent, SingleItemViewComponent],
})
export class ItemViewModule {}
